import {
  encodeData,
  decodeData
} from './encoding.js'
import {
  randomString
} from './random.js'

const STATE_PREFIX = 'mymsa.callback.'

// externalRedirect redirects the browser to the provided URL. Sets the provided data
// in local storage with a state and nonce key so it can be retrieved on return.
export function externalRedirect (_url, data = {}) {
  const url = new URL(_url)
  const state = randomString()
  const nonce = randomString()
  const key = STATE_PREFIX + state
  const payload = {
    nonce,
    data
  }
  window.localStorage.setItem(key, encodeData(payload))
  url.searchParams.set('state', state)
  url.searchParams.set('nonce', nonce)
  url.searchParams.set('redirect_uri', window.location.toString())
  window.location.assign(url.toString())
}

// externalRedirectCallback resolves the payload
// from local storage, via the provided state and nonce.
export function externalRedirectCallback (state, nonce) {
  if (!state) throw new Error('Missing state.')
  if (!nonce) throw new Error('Missing nonce.')
  const key = STATE_PREFIX + state
  const encoded = window.localStorage.getItem(key)
  window.localStorage.removeItem(key)
  if (!encoded) throw new Error('State not found in storage.')
  const payload = decodeData(encoded)
  if (payload.nonce !== nonce) throw new Error('Nonce mismatch.')
  return payload.data
}
